import React, { FC, useMemo } from 'react';

import getGolfClubInfo from '../../services/apis/golfCourses/getGolfClubInfo';
import { MappedGolfCourseType } from '../../services/apis/golfCourses/types';
import Carousel, { CarouselProps } from '../Carousel/Carousel';

interface GolfClubCarouselProps {
  golfCourse: MappedGolfCourseType;
}

const GolfClubCarousel: FC<GolfClubCarouselProps> = ({ golfCourse }) => {
  const golfCourseInfo = useMemo(() => getGolfClubInfo(golfCourse), [golfCourse]);

  const carouselImages = useMemo<CarouselProps['items']>(() => {
    const result: CarouselProps['items'] = [];

    if (golfCourseInfo?.photos?.length) {
      golfCourseInfo.photos.forEach(item => {
        result.push({
          src: item.assetPath,
          alt: item.name,
          style: {
            width: '100%',
            height: '60vh',
            objectFit: 'cover',
            objectPosition: 'center',
          },
        });
      });
    } else if (golfCourseInfo?.image) {
      result.push({
        src: golfCourseInfo.image,
        alt: '',
        style: {
          width: '100%',
          height: '60vh',
          objectFit: 'cover',
          objectPosition: 'center',
        },
      });
    }

    return result;
  }, [golfCourseInfo?.photos, golfCourseInfo?.image]);

  return <Carousel className="w-100 overflow-hidden" items={carouselImages} />;
};

export default GolfClubCarousel;
